import { render } from "./BankAccountInputForm.vue?vue&type=template&id=89f466ce"
import script from "./BankAccountInputForm.vue?vue&type=script&lang=ts"
export * from "./BankAccountInputForm.vue?vue&type=script&lang=ts"
script.render = render

export default script